import { jsx } from "react/jsx-runtime";
import "react";
import PropTypes from "prop-types";
import { List } from "@zillow/zrs-cms";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
import { usePlacement } from "../../components/PlacementProvider/PlacementProvider.esm.js";
const BlockList = ({
  attrs,
  index,
  innerBlocks
}) => {
  const isPost = usePlacement() === "post";
  const {
    margin = {},
    ...rest
  } = attrs;
  const marginTop = {
    default: "none",
    lg_lte: "none",
    sm_lte: "none",
    ...margin == null ? void 0 : margin.marginTop
  };
  const marginBottom = {
    default: "none",
    lg_lte: "none",
    sm_lte: "none",
    ...margin == null ? void 0 : margin.marginBottom
  };
  return /* @__PURE__ */ jsx(List, { ...rest, ...!isPost && {
    marginBottom,
    marginTop
  }, ...isPost && {
    paddingBottom: "sm"
  }, children: generateBlockList({
    blocks: innerBlocks
  }) }, index);
};
BlockList.propTypes = {
  attrs: PropTypes.shape({}),
  index: PropTypes.number,
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({}))
};
export {
  BlockList as default
};
